/* eslint-disable @typescript-eslint/no-explicit-any */
import { cn } from "@/lib/utils";
import InputComponent, { TextArea } from "@/src/components/Input/Input";
import { Label, textVariants } from "@/src/components/Text/Text";
import { Question } from "@/src/layouts/Dashboard/types";
import { sanitizeKey } from "@/src/utils";
import { FieldValues, UseFormReturn } from "react-hook-form";

export const QuestionComponent = ({
  question,
  form,
  errors,
}: {
  question: Question;
  form: UseFormReturn<FieldValues, any>;
  errors: string;
}) => {
  const { register, watch, setValue } = form;
  return (
    <div className="w-full">
      {["date", "number"].includes(question.input_type) && (
        <InputComponent
          label={question?.question}
          {...register(sanitizeKey(question.question))}
          type={question.input_type}
          required={!question.optional}
          errors={errors}
        />
      )}
      {["text"].includes(question.input_type) && (
        <TextArea
          label={question?.question}
          {...register(sanitizeKey(question.question))}
          required={!question.optional}
          errors={errors}
        />
      )}
      {["radio", "checkbox"].includes(question.input_type) && (
        <Label className={cn(textVariants({ font: "semibold" }))}>
          {question.question}
        </Label>
      )}
      {question.input_type === "radio" &&
        question.options?.map((option, index) => (
          <div>
            <div className="flex items-center gap-2" key={index}>
              <input
                {...register(sanitizeKey(question.question))}
                type={question.input_type}
                required={!question.optional}
                value={option}
              />
              <Label>{option}</Label>
            </div>
          </div>
        ))}
      {question.input_type === "checkbox" &&
        question.options?.map((option, index) => (
          <div>
            <div className="flex items-center gap-2" key={index}>
              <input
                onChange={(e) => {
                  const selectedOptions = watch(question.question)
                    ? [...watch(question.question)]
                    : [];
                  if (e.target.checked) {
                    selectedOptions.push(option); // Add to the array
                  } else {
                    selectedOptions.splice(selectedOptions.indexOf(option), 1); // Remove from the array
                  }
                  setValue(sanitizeKey(question.question), selectedOptions); // Update the field value
                }}
                type={question.input_type}
                required={!question.optional}
                value={option}
                checked={watch(question.question)?.includes(option)}
              />
              <Label>{option}</Label>
            </div>
          </div>
        ))}
      {["checkbox", "radio"].includes(question.input_type) && errors && (
        <span className="text-red-500 text-xs font-medium">{errors}</span>
      )}
    </div>
  );
};
